module.exports = __webpack_public_path__ + "static/wareef-scalable-solutions-51cf119b07f7a61179c91d144c1f0613.jpg";